/* LP - fills any [data-lp-countdown] with a live countdown.
   Optional data-end="2026-08-01T23:59:59" - otherwise counts to midnight.

   A plain date-time is read in the shopper's own timezone. Add a Z or an
   offset to pin it to one absolute moment for everyone.

   Days only appear once there is more than a day left, so the daily midnight
   bars on the other landing pages render exactly as they always have. */
(function () {
  function two(n) { return n < 10 ? '0' + n : '' + n; }

  function endFor(el) {
    var iso = el.getAttribute('data-end');
    if (iso) {
      var d = new Date(iso);
      if (!isNaN(d.getTime())) return d.getTime();
    }
    var midnight = new Date();
    midnight.setHours(24, 0, 0, 0);
    return midnight.getTime();
  }

  function tick() {
    var els = document.querySelectorAll('[data-lp-countdown]');
    if (!els.length) return;

    var now = Date.now();
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      var left = Math.max(0, Math.floor((endFor(el) - now) / 1000));
      var days = Math.floor(left / 86400);
      var h = Math.floor((left % 86400) / 3600);
      var m = Math.floor((left % 3600) / 60);
      var s = left % 60;
      var out = two(h) + 'h ' + two(m) + 'm ' + two(s) + 's';
      if (days > 0) out = days + 'd ' + out;
      el.textContent = out;
    }
  }

  tick();
  setInterval(tick, 1000);
})();
